import React from "react";
import PropTypes from "prop-types";
import EmptyContent from "components/EmptyContent";
import MarkdownRenderer from "components/MarkdownRenderer/MarkdownRenderer";
import CollapsibleDrawerContent from "../../components/CollapsibleDrawerContent/CollapsibleDrawerContent";

const TextSection = ({text, title}) => {
  const content = text ? (
    <MarkdownRenderer value={text} tableFormat="itemsIfTwoColumns" />
  ) : (
    <EmptyContent name={title} />
  );

  return (
    <CollapsibleDrawerContent title={title} defaultCollapsed={!text}>
      {content}
    </CollapsibleDrawerContent>
  );
};

TextSection.propTypes = {
  /**
   * The text content that renders when the collapsible content is expanded.
   */
  text: PropTypes.string,

  /**
   * The text that renders in the collapsible content's title.
   */
  title: PropTypes.string
};

export default TextSection;
